const items = [
    {
      title: 'Tecnologia',
      key: 'Tecnologia',
      icon: 'far fa-cog',
      description: 'Tecnologia de ponta de alta performance'
    },
    {
      title: 'Consistência',
      key: 'Consistencia',
      icon: 'far fa-layer-group',
      description: 'Código de programação versátil e consistente'
    },
    {
      title: 'Dados protegidos',
      key: 'dados',
      icon: 'far fa-shield-alt',
      description: 'Banco de dados seguro e protegido'
    },
    {
      title: 'Bibliotecas',
      key: 'Bibliotecas',
      icon: 'far fa-folder-open',
      description: 'Bibliotecas com recursos avançados'
    },
    
    
  ]
  export {
    items 
  }